import { z } from 'zod';

import { ToneModeEnum } from '../../enums';
import { levelEnumValidator, toneModeEnumValidator } from '../../validators';

export const RephraseSentenceSchema = z.object({
  level: levelEnumValidator.optional(),
  sentence: z.string().min(1, 'Sentence cannot be empty.'),
  tone: toneModeEnumValidator.optional().default(ToneModeEnum.FLUID),
});

export type IRephraseSentenceDto = z.infer<typeof RephraseSentenceSchema>;
